export enum MONTHLY_CHECK_SUBMISSTION_STATUS {
  ANSWERED = "true",
  UNANSWERED = "false",
}
